var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _g, _line11, _line12, _line13, _line14, _g2, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 733.5 672.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 77.558,
    y1: 54.014,
    x2: 77.558,
    y2: 660.047,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 702.395,
    y1: 54.164,
    x2: 702.395,
    y2: 660.196,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 702.733,
    y1: 659.686,
    x2: 77.779,
    y2: 659.686,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 707.401,
    y1: 596.222,
    x2: 82.447,
    y2: 596.222,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 707.793,
    y1: 118.009,
    x2: 82.84,
    y2: 118.009,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 702.362,
    y1: 54.124,
    x2: 77.434,
    y2: 54.124,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 231.367,
    y1: 88.164,
    x2: 231.367,
    y2: 625.697,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 323.676,
    y1: 88.937,
    x2: 323.676,
    y2: 626.47,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 449.472,
    y1: 90.819,
    x2: 449.472,
    y2: 628.353,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 543.253,
    y1: 91.981,
    x2: 543.253,
    y2: 629.514,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 696.205,
    y1: 360.728,
    x2: 690.205,
    y2: 360.728,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 678.186,
    y1: 360.728,
    x2: 83.26,
    y2: 360.728,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.019 12.019",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.251,
    y1: 360.728,
    x2: 71.251,
    y2: 360.728,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 286.345,
    y1: 404.59,
    x2: 234.834,
    y2: 404.59,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 326.976,
    y1: 495.143,
    x2: 275.464,
    y2: 495.143,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 546.052,
    y1: 404.771,
    x2: 494.54,
    y2: 404.771,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 499.705,
    y1: 494.891,
    x2: 448.193,
    y2: 494.891,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 388.131,
    y1: 654.686,
    x2: 388.131,
    y2: 648.686,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.131,
    y1: 636.521,
    x2: 388.131,
    y2: 83.011,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.165 12.165",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.131,
    y1: 76.929,
    x2: 388.131,
    y2: 70.929,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 138.111,
    y1: 58.493,
    x2: 138.111,
    y2: 113.906,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 138.055,
    y1: 121.6,
    x2: 138.055,
    y2: 149.655,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 138.001,
    y1: 202.93,
    x2: 138.001,
    y2: 266.606,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 138.131,
    y1: 319.835,
    x2: 138.131,
    y2: 388.843,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 138.015,
    y1: 441.925,
    x2: 138.015,
    y2: 510.933,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 138.06,
    y1: 564.406,
    x2: 138.06,
    y2: 654.283,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 636.572,
    y1: 58.477,
    x2: 636.572,
    y2: 113.89,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 636.516,
    y1: 121.584,
    x2: 636.516,
    y2: 149.638,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 636.462,
    y1: 202.914,
    x2: 636.462,
    y2: 266.59,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 636.592,
    y1: 319.819,
    x2: 636.592,
    y2: 388.826,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 636.476,
    y1: 441.909,
    x2: 636.476,
    y2: 510.917,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 636.521,
    y1: 564.39,
    x2: 636.521,
    y2: 654.266,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 697.425,
    y1: 155.002,
    x2: 620.082,
    y2: 155.002,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 697.481,
    y1: 197.617,
    x2: 620.138,
    y2: 197.617,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 619.844,
    y1: 198.147,
    x2: 619.844,
    y2: 155.002,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 696.909,
    y1: 271.851,
    x2: 619.566,
    y2: 271.851,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 696.965,
    y1: 314.466,
    x2: 619.622,
    y2: 314.466,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 619.327,
    y1: 314.996,
    x2: 619.327,
    y2: 271.851,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 697.528,
    y1: 394.293,
    x2: 620.185,
    y2: 394.293,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 697.584,
    y1: 436.908,
    x2: 620.241,
    y2: 436.908,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 619.947,
    y1: 437.438,
    x2: 619.947,
    y2: 394.293,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 697.717,
    y1: 516.05,
    x2: 620.374,
    y2: 516.05,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 697.773,
    y1: 558.666,
    x2: 620.43,
    y2: 558.666,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 620.136,
    y1: 559.195,
    x2: 620.136,
    y2: 516.051,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 82.27,
    y1: 155.395,
    x2: 159.613,
    y2: 155.395,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 82.213,
    y1: 198.011,
    x2: 159.556,
    y2: 198.011,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 159.851,
    y1: 198.54,
    x2: 159.851,
    y2: 155.396,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 82.786,
    y1: 272.244,
    x2: 160.129,
    y2: 272.244,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 82.73,
    y1: 314.859,
    x2: 160.073,
    y2: 314.859,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 160.367,
    y1: 315.389,
    x2: 160.367,
    y2: 272.244,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 82.167,
    y1: 394.686,
    x2: 159.51,
    y2: 394.686,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 82.11,
    y1: 437.301,
    x2: 159.453,
    y2: 437.301,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 159.748,
    y1: 437.831,
    x2: 159.748,
    y2: 394.686,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 81.978,
    y1: 516.444,
    x2: 159.321,
    y2: 516.444,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 81.922,
    y1: 559.059,
    x2: 159.264,
    y2: 559.059,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 159.559,
    y1: 559.588,
    x2: 159.559,
    y2: 516.444,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "108.541 110.466 96.816 100.128 96.816 79.766 103.744 73.657 118.489 73.657 125.773 80.079 125.773 102.321 108.541 110.466",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "666.347 109.505 654.622 99.244 654.622 79.032 661.55 72.969 676.295 72.969 683.578 79.343 683.578 101.42 666.347 109.505",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "108.995 647.139 97.27 636.486 97.27 615.502 104.198 609.207 118.943 609.207 126.227 615.825 126.227 638.746 108.995 647.139",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "668.041 646.687 656.316 636.685 656.316 616.986 663.244 611.076 677.989 611.076 685.273 617.289 685.273 638.807 668.041 646.687",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m517.846,89.925v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m426.128,88.182v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m299.525,89.497v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m208.045,88.299v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m209.225,631.079v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m299.665,630.004v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m425.908,630.038v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m514.9,630.527v-14.092l40.062-.201-.201,7.247h7.247v6.04h-10.67v7.449h-25.769v-6.643s-9.965.906-10.67.201Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(100.814 38.308)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(264.535 38.012)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(467.289 38.038)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(631.563 37.932)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(23.934 91.006)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(23.411 271.654)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42,
    letterSpacing: "-.018em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(24.145 473.867)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(467.289 38.038)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(24.211 648.775)",
    fontFamily: "ArialMT, Arial",
    fontSize: 42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorContainer);
export default __webpack_public_path__ + "static/media/Door Container.ebff6633f2256ed5fa26c67e3bce57a4.svg";
export { ForwardRef as ReactComponent };